null


// WEBPACK FOOTER //
// https://raw.githubusercontent.com/scala/scala/v2.12.11/src/library/scala/concurrent/Promise.scala